import React, { useMemo } from 'react';
import { DatePicker, DateTimePicker, TimePicker, } from '@mui/x-date-pickers-pro';
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import { DateTime } from 'luxon';
import { useCompanyDateTime } from './useCompanyDateTime';
export var DateTimeInputMode;
(function (DateTimeInputMode) {
    DateTimeInputMode[DateTimeInputMode["DATE"] = 0] = "DATE";
    DateTimeInputMode[DateTimeInputMode["TIME"] = 1] = "TIME";
    DateTimeInputMode[DateTimeInputMode["DATE_TIME"] = 2] = "DATE_TIME";
})(DateTimeInputMode || (DateTimeInputMode = {}));
export const DateTimeInput = ({ name, mode, value, label, onChange, dateTimeSeparator = ' - ', dataCy, ...formikFieldProps }) => {
    const { dateFormat, timeFormat, timeZoneIana, hourCycle12 } = useCompanyDateTime();
    const { values, setFieldValue, setFieldTouched } = useFormikContext();
    // KeyboardDatePicker will break if value is an empty string or undefined
    // This ensures an expected value of null is passed
    const fieldValue = useMemo(() => {
        const v = value ?? get(values, name);
        if (v === null || v === undefined || v === '')
            return null;
        const d = DateTime.fromISO(v).setZone(timeZoneIana);
        if (d && !d.isValid) {
            const m = [
                'Invalid date/time format.',
                'Value must be a valid ISO 8601 string.',
                `Value: "${v}".`,
            ];
            if (name)
                m.push(`Field name: "${name}".`);
            console.error(m.join(' '));
        }
        return d;
    }, [name, value, values, timeZoneIana]);
    if (mode === DateTimeInputMode.DATE_TIME)
        return (React.createElement(DateTimePicker, { slotProps: {
                textField: {
                    fullWidth: true,
                    variant: 'outlined',
                    ...formikFieldProps,
                },
            }, name: name, label: label, format: `${dateFormat}${dateTimeSeparator}${timeFormat}`, value: fieldValue, "data-cy": dataCy || `field-${name}`, disabled: formikFieldProps.disabled, timezone: timeZoneIana, ampm: !!hourCycle12, ampmInClock: !!hourCycle12, onChange: v => {
                setFieldValue(name, v?.toISO() ?? null);
                setFieldTouched(name, true, false);
                setTimeout(() => {
                    onChange?.(v?.toISO() ?? null);
                }, 100);
            } }));
    if (mode === DateTimeInputMode.TIME)
        return (React.createElement(TimePicker, { slotProps: {
                textField: {
                    fullWidth: true,
                    variant: 'outlined',
                    ...formikFieldProps,
                },
            }, openTo: "hours", views: ['hours', 'minutes'], format: timeFormat, label: label, value: fieldValue, "data-cy": dataCy || `field-${name}`, disabled: formikFieldProps.disabled, timezone: timeZoneIana, ampm: !!hourCycle12, ampmInClock: !!hourCycle12, onChange: v => {
                setFieldValue(name, v?.toISO() ?? null);
                setFieldTouched(name, true, false);
                setTimeout(() => {
                    onChange?.(v?.toISO() ?? null);
                }, 100);
            } }));
    if (mode === DateTimeInputMode.DATE)
        return (React.createElement(DatePicker, { slotProps: {
                textField: {
                    fullWidth: true,
                    variant: 'outlined',
                    ...formikFieldProps,
                },
            }, format: dateFormat, label: label, value: fieldValue, "data-cy": dataCy || `field-${name}`, disabled: formikFieldProps.disabled, timezone: timeZoneIana, onChange: v => {
                setFieldValue(name, v?.toISO() ?? null);
                setFieldTouched(name, true, false);
                setTimeout(() => {
                    onChange?.(v?.toISO() ?? null);
                }, 100);
            } }));
    return React.createElement(React.Fragment, null);
};
export default DateTimeInput;
